// extracted by mini-css-extract-plugin
export default {"questions":"questions___cee295e18a521cd8"};